import { Injectable, signal } from "@angular/core";
import { environment } from "@environments/environment";
import { GroupConfig } from "@environments/environment.interface";
export { type GroupConfig } from "@environments/environment.interface";

const GROUP_CONFIG = environment.GROUP_CONFIG;

@Injectable({
  providedIn: 'root'
})
export class GroupConfigService {
  get groupId(){ return this.current()?.groupId; }
  get isSaga(){ return this.current()?.isSaga ?? false; }
  get backUrl(){ return this.current()?.backUrl; }
  get catch_copy(){ return this.current()?.catch_copy ?? false; }
  get tags(){ return this.current()?.tags ?? [{rel:'icon', href:`favicon.ico`}]; }
  get hasFaviconTag(){ return this.$hasFaviconTag; }
  readonly current = signal<GroupConfig | undefined>(undefined);

  protected $hasFaviconTag = false;
  //
  public set(groupId:string){
    const config = GROUP_CONFIG.find( $_ => $_.groupId === groupId);
    this.current.set(config);
    // set後の処理
    this.$hasFaviconTag = this.tags.findIndex($_ => $_.rel === 'icon') >= 0; 
    return this;
  }
  //
  public reset(){
    this.current.set(undefined);
    this.$hasFaviconTag = false;
    return this;
  }
}
